import { Elements } from '@tfo/common'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { CopyableInputField } from '../SensitiveInputField'
import { MappingRows, useScimStyles } from './scimShared'

const { Paragraph, Label } = Elements

type Props = {
  revealedToken: string | null
  endpointUrl: string | null
  mappingExpanded: boolean
  onExpandMapping: () => void
  errorKey: string | null
}

export const ScimActiveWithTokenView: React.FC<Props> = ({
  revealedToken,
  endpointUrl,
  mappingExpanded,
  onExpandMapping,
  errorKey,
}) => {
  const intl = useIntl()
  const styles = useScimStyles()

  return (
    <>
      <Paragraph>{intl.formatMessage({ id: 'sso.scim.activation.description' })}</Paragraph>
      {revealedToken && (
        <div className={styles.tokenBanner}>
          <div className={styles.tokenBannerTitle}>
            <ReportProblemOutlinedIcon fontSize='small' />
            {intl.formatMessage({ id: 'sso.scim.token.banner.title' })}
          </div>
          <Paragraph className={styles.tokenBannerSubtitle}>
            {intl.formatMessage({ id: 'sso.scim.token.banner.subtitle' })}
          </Paragraph>
          <CopyableInputField
            value={revealedToken}
            sensitive
            copyValueLabel={intl.formatMessage({ id: 'sso.scim.copy' })}
            copyValue={() => navigator.clipboard.writeText(revealedToken)}
          />
        </div>
      )}
      <div className={styles.section}>
        <Label>{intl.formatMessage({ id: 'sso.scim.endpoint.label' })}</Label>
        <CopyableInputField
          value={endpointUrl}
          copyValueLabel={intl.formatMessage({ id: 'sso.scim.copy' })}
          copyValue={() => navigator.clipboard.writeText(endpointUrl)}
        />
      </div>
      <div className={styles.section}>
        <Label>
          {intl.formatMessage({ id: 'sso.scim.mapping.label' })} {intl.formatMessage({ id: 'sso.scim.mapping.fixed' })}
        </Label>
        <table className={styles.mappingTable}>
          <thead>
            <tr>
              <th>{intl.formatMessage({ id: 'sso.scim.mapping.column.scim' })}</th>
              <th>{intl.formatMessage({ id: 'sso.scim.mapping.column.tfo' })}</th>
            </tr>
          </thead>
          <tbody>
            {MappingRows.map((row) => (
              <tr key={row.scim}>
                <td className={styles.mappingScimCell}>{row.scim}</td>
                <td>{intl.formatMessage({ id: row.tfoKey })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {errorKey && <Paragraph className={styles.errorText}>{intl.formatMessage({ id: errorKey })}</Paragraph>}
    </>
  )
}
